import { Component } from '@angular/core';
import { CaseManagement } from 'src/app/models/CaseManagement.model';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../.././models/Constants';

@Component({
  selector: 'app-customer-case-management-card',
  templateUrl: './customer-case-management-card.component.html',
  styleUrls: ['./customer-case-management-card.component.scss'],
})
export class CustomerCaseManagementCardComponent {
  // showCaseManagement: boolean = false;
  // caseManagement: CaseManagement[] = [];
  // custAccCaseManagementLoader: boolean = false;
  // showLoaderMsg: boolean = false;
  // loaderTimeoutId: any;
  // isCaseManagementErrorEnabled: boolean = false;
  // loaderType = Constants.LOADER_TYPE.CARD;
  public iconConfig = {
    iconName: 'arrow-right',
    iconType: 'light',
    iconPlacement: 'right',
  };
  constructor(
    public customerAccountService: CustomerAccountBusinessLogicService,
    public rootScopeService: RootScopeService
  ) {}

 

  // //getCaseManagementsDetail method is fetching the data of CaseManagement(linkLable & uri of Case Management) by hitting the backend Service.
  // /* istanbul ignore next */
  // getCaseManagementDetail() {
  //   this.startTimerForLoader();
  //   this.isCaseManagementErrorEnabled = false;
  //   this.custAccCaseManagementLoader = true;
  //   this.customerAccountService.getCaseManagementDetails().subscribe({
  //     next: (res: CaseManagement[]) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.custAccCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       this.caseManagement = res;
  //       this.showCaseManagement = true;
  //     },
  //     error: (error) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.custAccCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       this.isCaseManagementErrorEnabled = true;
  //     },
  //   });
  // }

  // //goToCaseManagement method open SSOLink in new Tab
  // /* istanbul ignore next */
  // goToCaseManagement(uri: string) {
  //   this.startTimerForLoader();
  //   this.isCaseManagementErrorEnabled = false;
  //   this.custAccCaseManagementLoader = true;
  //   this.customerAccountService.getSSOLink(uri).subscribe({
  //     next: (res) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.custAccCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       let winUrl = URL.createObjectURL(
  //         new Blob([res], { type: 'text/html' })
  //       );
  //       this.rootScopeService.openNewTab(winUrl);
  //     },
  //     error: (error) => {
  //       clearTimeout(this.loaderTimeoutId);
  //       this.custAccCaseManagementLoader = false;
  //       this.showLoaderMsg = false;
  //       this.isCaseManagementErrorEnabled = true;
  //     },
  //   });
  // }

  // startTimerForLoader() {
  //   this.loaderTimeoutId = setTimeout(() => {
  //     this.showLoaderMsg = true;
  //   }, 1 * this.rootScopeService.showLoaderMsgThreshold * 1000);
  // }
  
/**
Handles the navigation to case management based on the selected link.
If the selected link's action code is "LINK_ACTION", it calls the selectedLeftNavBarLink method
of rootScopeService with the selected link and false as arguments.
If the selected link's action code is not "LINK_ACTION", it sets the myTodoErrMsg property
of customerAccountService.activeTabDt to the constant value CASE_MNGMT_API_FAIL_MSG.
@param selectedLink - The selected link object.
*/
  goToCaseManagement(selectedLink) {
    if (selectedLink?.actionCode === "LINK_ACTION") {
      this.rootScopeService.selectedLeftNavBarLink(selectedLink, false);
    } else {
      this.customerAccountService.activeTabDt.myTodoErrMsg = Constants.CASE_MNGMT_API_FAIL_MSG;
    }
  }
  
/**
Closes the warning by resetting the error messages and error flags.
If activeTabDt exists in customerAccountService, it sets the myTodoErrMsg property to 'NA'.
If activeCustTab exists in rootScopeService, it sets the isCustAccCaseManagementErrorEnabled flag to false.
*/
  closeWarning() {
    if (this.customerAccountService.activeTabDt) {
      this.customerAccountService.activeTabDt.myTodoErrMsg = 'NA';
    }
    if (this.rootScopeService.activeCustTab) {
      this.rootScopeService.activeCustTab.isCustAccCaseManagementErrorEnabled = false;
    }
  }
  
 
}
